import React, { useEffect, useState, useContext } from "react";
import "./ShareProfile.css";
import ShareProfileImg from "../../assets/images/shareProfile.png";
import { Link, useLocation, useParams } from "react-router-dom";

import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
// import translations from "./translation.json";
import { LanguageContext } from "../../Components/LanguageContext";
import { FaWhatsapp } from "react-icons/fa";
import { Carousel } from "react-bootstrap";
import { BsArrowLeft } from "react-icons/bs";

export function ShareProfile() {
  // const { language } = useContext(LanguageContext);
  // const location = useLocation();
  // const { Details } = location.state || {};
  const [shareData, setShareData] = useState([]);
  const [agencyName, setAgencyName] = useState([]);
  const [agentName, setAgentName] = useState();
  const [agentNumber, setAgentNumber] = useState();
  const params = useParams();
  // const [shared, setShared] = useState(false);  //for whatsapp button
  const [userName, setUserName] = useState();
  // const [userImg, setUserImg] = useState();
  const [userCaste, setUserCaste] = useState();
  const images = shareData?.images || [];
  const profile = shareData?.profile;

  //  for disable right click
  useEffect(() => {
    const handleRightClick = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleRightClick);

    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  async function LoadShareData(id) {
    try {
      const response = await axiosInstance.get(`share-on-whatsapp/${id}`);

      setShareData(response.data.data);
      setAgencyName(response.data.agency_name);
      setAgentName(response.data.full_name);
      setAgentNumber(response.data.agent_mobile);
      setUserCaste(response.data.data.caste);
      setUserName(response.data.data.name);
      // setUserImg(response.data.data.profile);
      console.log(
        "caste",
        response.data.data.caste,
        response.data.data.name,
        response.data.data.profile
      );
      console.log("sharedata", response.data.data);
    } catch (error) {
      console.error("Error fetching user details", error);
    }
  }

  function shareWhatsapp() {
    const currentUrl = window.location.href;
    const shareText = `Discover a profile you might be interested in.\n\nName: ${userName}\nCaste: ${userCaste}\nClick the link below to view full biodata, photos, and personal details:\n${currentUrl}\n\nPrivate & Confidential - Kindly respect the privacy of this profile`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareText)}`;

    window.open(whatsappUrl, "_blank");
    // setShared(true); // Hide the button after opening the link
  }
  useEffect(() => {
    LoadShareData(params.id);
  }, []);
  const token = localStorage.getItem("token");
  return (
    <div className="shareProfile-container">
      <div className="container">
        <div className="agency-container">
          <div className="agency-name">
            <Link
              to="/view-more"
              style={{ color: "#2B171B", marginRight: "10px" }}
            >
              <span>
                <BsArrowLeft />
              </span>
            </Link>
            {agencyName === "" || agencyName === "null" || agencyName === null
              ? "Nathicharami Agency"
              : agencyName}
          </div>
          <div>
            {token ? (
              <button className="btnShare" onClick={shareWhatsapp}>
                <span>
                  <FaWhatsapp />
                </span>
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="share-title">Bio Data</div>
        <div className="share-container">
          {/* <div className="shareImg">
            <img src={shareData?.profile?.[0] ?? ""} alt="profileImg" />
          </div> */}
          <div className="shareImg">
            {images.length > 0 ? (
              <Carousel className="shareCarousel">
                {images.map((img, index) => (
                  <Carousel.Item key={index}>
                    <a
                      href={img.image}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        className="d-block w-100"
                        src={img.image}
                        alt={`Slide ${index + 1}`}
                        style={{ maxHeight: "300px", objectFit: "contain" }}
                      />
                    </a>
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              <div className="altprofileImg">
                <img src={profile} alt="No profile available" />
              </div>
            )}
          </div>
          <div>
            <div className="shareProfile-name">{shareData.name}</div>
            <div className="shareprofile-subtitle"> Personal Details :</div>
            <div className="profile-detailsContainer">
              <div> Gender</div>
              <div>:</div>
              <div>{shareData.gender}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Date Of Birth</div>
              <div>:</div>
              <div>{shareData.dob}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Age</div>
              <div>:</div>
              <div>{shareData.age}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Time Of Birth</div>
              <div>:</div>
              <div>{shareData.tob}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Place Of Birth</div>
              <div>:</div>
              <div>{shareData.pob}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Rashi</div>
              <div>:</div>
              <div>{shareData.rashi}</div>
            </div>
            <div className="profile-detailsContainer">
              <div>Nakshatra</div>
              <div>:</div>
              <div>{shareData.nakshatra}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Height</div>
              <div>:</div>
              <div>{shareData.height}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Marital Status</div>
              <div>:</div>
              <div>{shareData.marital_status}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Religion</div>
              <div>:</div>
              <div>{shareData.religion}</div>
            </div>
            <div className="profile-detailsContainer">
              <div>Mother Tongue</div>
              <div>:</div>
              <div>{shareData.mother_tongue}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Caste</div>
              <div>:</div>
              <div>{shareData.caste}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Sub Caste</div>
              <div>:</div>
              <div>{shareData.sub_caste}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Gothram</div>
              <div>:</div>
              <div>{shareData.gotra}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Manglik</div>
              <div>:</div>
              <div>{shareData.manglik}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Education</div>
              <div>:</div>
              <div>{shareData.education}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> College Name</div>
              <div>:</div>
              <div>{shareData.college_name}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Employee Designation</div>
              <div>:</div>
              <div>{shareData.employed_in}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Organization Name</div>
              <div>:</div>
              <div>{shareData.organization_name}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Annual Income</div>
              <div>:</div>
              <div>{shareData.annual_income}</div>
            </div>

            <div className="shareprofile-subtitle"> Family Details :</div>
            <div className="profile-detailsContainer">
              <div> Father’s Name</div>
              <div>:</div>
              <div>{shareData.father_name}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Father’s Occupation</div>
              <div>:</div>
              <div>{shareData.father_occupation}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Mother’s Name</div>
              <div>:</div>
              <div>{shareData.mother_name}</div>
            </div>
            <div className="profile-detailsContainer">
              <div>Mother’s Occupation</div>
              <div>:</div>
              <div>{shareData.mother_occupation}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> No. of Brothers</div>
              <div>:</div>
              <div>{shareData.total_brothers}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> No. of Sisters</div>
              <div>:</div>
              <div>{shareData.total_sisters}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Married Brothers</div>
              <div>:</div>
              <div>{shareData.married_brothers}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Married Sisters</div>
              <div>:</div>
              <div>{shareData.married_sisters}</div>
            </div>

            <div className="shareprofile-subtitle">Agent Details :</div>
            <div className="profile-detailsContainer">
              <div> Agent Name</div>
              <div>:</div>
              <div>{agentName}</div>
            </div>
            <div className="profile-detailsContainer">
              <div> Agent Number</div>
              <div>:</div>
              <div>{agentNumber}</div>
            </div>
            {/* <div className="profile-detailsContainer">
              <div> {translations[language].address1}</div>
              <div>:</div>
              <div>{shareData.address_l1}</div>
            </div> */}
            {/* <div className="profile-detailsContainer">
              <div> {translations[language].address2}</div>
              <div>:</div>
              <div>{shareData.address_l2}</div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
